import * as Yup from 'yup';
import {number, string} from 'yup';

export type ID = any;

export interface IModel {
    id: ID;
}

export const IDSchema = Yup.mixed<ID>().test({
    test: (value: any) => !!value
});
